<template>
  <div>
    
    <div class="form-request" v-if="projectLocal != null">

      <div class="inputs-form">

        <div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
          {{message}}
        </div>      

        <div class="content-tab">
          <p id="title-forms" class="title-step">Empecemos con tu información personal</p>
        </div>

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Nombre</p>
          <input type="text" class="inputRequest " id="first_name" placeholder="Nombre" v-model="projectLocal.first_name">          
        </div>

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Apellidos</p>
          <input type="text" class="inputRequest" id="last_name" placeholder="Apellidos" v-model="projectLocal.last_name">              
        </div>

        <div class="col-sm-12">
          <p class="myLabelTabs" for="observations">Sexo</p>
          <b-form-select v-model="projectLocal.gender" :options="selects.genders" class="select-request" value-field="id" text-field="name"></b-form-select>      
        </div>        

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Ciudad de nacimiento</p>          
          <select-local :model.sync="projectLocal.birth_city_id" :items="selects.cities"/>      
        </div>        

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Fecha de nacimiento</p>          
          <input type="date" class="inputRequest" id="birth_date" v-model="projectLocal.birth_date">      
        </div>                        

        <div class="col-sm-12">
          <p class="myLabelTabs" for="observations">Estado civil</p>          
          <b-form-select v-model="projectLocal.civil_type" :options="selects.civil_types" class="select-request" value-field="id" text-field="name"></b-form-select>      
        </div>        

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Años de experiencia laboral</p>          
          <input type="number" class="inputRequest" id="birth_date" v-model="projectLocal.years_experience" min="0" max="100">      
        </div>                

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Grupo sanguíneo</p>          
          <b-form-select v-model="projectLocal.blood_type" :options="selects.blood_types" class="select-request" value-field="id" text-field="name"></b-form-select>      
        </div>

        <div class="content-tab">
          <p id="title-forms" class="title-step">Información de documento de identidad</p>
        </div>

        <div class="col-sm-3">
          <p class="myLabelTabs" for="observations">Tipo de documento</p>          
          <b-form-select v-model="projectLocal.person_id_type" :options="selects.id_types" class="select-request" value-field="id" text-field="name"></b-form-select>      
        </div>
        
        <div class="col-sm-3">
          <p class="myLabelTabs" for="observations">Documento</p>          
          <input type="text" class="inputRequest" id="person_id" placeholder="Apellidos" v-model="projectLocal.person_id">              
        </div>        

        <div class="col-sm-3">
          <p class="myLabelTabs" for="observations">Fecha de expedición</p>          
          <input type="date" class="inputRequest" id="identification_expedition_date" placeholder="Apellidos" v-model="projectLocal.identification_expedition_date">      
        </div>
        
        <div class="col-sm-3">
          <p class="myLabelTabs" for="observations">Ciudad de expedición</p>          
          <select-local :model.sync="projectLocal.identification_city_id" :items="selects.cities"/>      
        </div>

        <div class="content-tab">
          <p id="title-forms" class="sub-section">Información de contacto</p>
        </div>        

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Teléfono</p>          
          <input type="text" class="inputRequest" id="telephone_1" placeholder="Nombre" v-model="projectLocal.telephone_1">      
        </div>
        
        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Email</p>          
          <input type="text" class="inputRequest" id="email_1" placeholder="Nombre" v-model="projectLocal.email_1">      
        </div>        

        <div class="content-tab">
          <p id="title-forms" class="sub-section">Información de vehículo</p>
        </div>                

        <div class="col-sm-12">
          <p class="myLabelTabs" for="observations">Placa</p>          
          <input type="text" class="inputRequest" id="vehicle_plate" placeholder="Placa" v-model="projectLocal.vehicle_plate">      
        </div>        

        <div class="content-tab">
          <p id="title-forms" class="sub-section">Dirección</p>
        </div>                

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Ciudad de residencia</p>          
          <select-local :model.sync="projectLocal.city_id" :items="selects.cities"/>      
        </div>        

        <div class="col-sm-6">
          <p class="myLabelTabs" for="observations">Dirección</p>          
          <input type="text" class="inputRequest" id="email_1" placeholder="Dirección" v-model="projectLocal.address">      
        </div>                

        <div class="col-sm-12 container-map-candidate">
          <p class="myLabelTabs" for="observations">Por favor ayudanos ubicando tu vivienda. Haz doble click sobre tu ubicación</p>
          <div :class="`alert ${typeMessageMaker}`" role="alert" id="message-update" v-if="messageMaker != ''">
            {{messageMaker}}
          </div>                
          <GmapMap :center="center" :zoom="12" style="width:100%;  height: 400px;" :clickable="true" @dblclick="addMaker($event.latLng)">
            <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" @click="center=m.position"></GmapMarker>
          </GmapMap>
        </div>        

        <template v-if="projectLocal.gender == 1">

          <div class="content-tab">
            <p id="title-forms" class="sub-section">Información militar</p>
          </div>

          <div class="col-sm-6">
            <p class="myLabelTabs" for="observations">Libreta militar #</p>          
            <input type="text" class="inputRequest" id="militar_id" placeholder="#" v-model="projectLocal.militar_id">      
          </div>
          
          <div class="col-sm-6">
            <p class="myLabelTabs" for="observations">Clase</p>          
            <input type="text" class="inputRequest" id="militar_class" placeholder="Primera / Segunda" v-model="projectLocal.militar_class">      
          </div>        
        </template>

      </div>

    </div>       

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters } from 'vuex'
import SelectLocal from './../../own/select-local-request.vue'
import UploadMultipleFile from './../../own/upload-multiple-file.vue'
import { eventBus } from './../../../application'
export default {
  name: 'InformationPersonal',
  props: ['project'],
  computed: {
    ...mapGetters(['selects'])
  },    
  data() {
    return {
			message: '',
      typeMessage: '',
			messageMaker: '',
      typeMessageMaker: '',      
      projectLocal: this.project,
      required_fields: [
        {key: 'first_name', message: 'El campo nombre es requerido. '},
        {key: 'last_name', message: 'El campo apellidos es requerido. '},
        {key: 'gender', message: 'El campo sexo es requerido. '},
        {key: 'birth_city_id', message: 'El campo ciudad de nacimiento es requerido. '},
        {key: 'birth_date', message: 'El campo fecha de nacimiento es requerido. '},
        {key: 'civil_type', message: 'El campo estado civil es requerido. '},
        {key: 'years_experience', message: 'El campo años de experiencia laboral es requerido. '},
        {key: 'blood_type', message: 'El campo grupo sanguíneo es requerido. '},
        {key: 'person_id_type', message: 'El campo tipo de documento es requerido. '},
        {key: 'person_id', message: 'El campo documento es requerido. '},
        {key: 'identification_expedition_date', message: 'El campo fecha de expedición es requerido. '},
        {key: 'identification_city_id', message: 'El campo ciudad de expedición es requerido. '},
        {key: 'telephone_1', message: 'El campo teléfono es requerido. '},
        {key: 'email_1', message: 'El campo email es requerido. '}
      ],
      map: null,
      updateMap: true,
      center: {lat: 4.355, lng: -74.045},
      markers: [],
      places: [],
      currentPlace: null            
    }
  },
  components: {
    'select-local': SelectLocal,
    'upload-multiple-file': UploadMultipleFile    
  },
  methods: {
    addMaker(latLng) {
      let lat = latLng.lat()
      let lng = latLng.lng()
      if (lat != null && lng != null) {
        const marker = {
          lat: lat,
          lng: lng
        };
        this.markers[0] = { position: marker };
        this.center = marker;
        this.projectLocal.latitude = marker.lat
        this.projectLocal.longitude = marker.lng        
      }
      this.showMessageMaker('Ubicación seleccionada con éxito', 'alert-success')
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker()
    },    
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers[0] = { position: marker };
        this.places[0] = this.currentPlace;
        this.center = marker;
        this.projectLocal.address = this.currentPlace.formatted_address
        this.projectLocal.latitude = marker.lat
        this.projectLocal.longitude = marker.lng
      }
    },    
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.markers[0] = { position: this.center };
      });
    },        
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    save(){
      this.defaultAxios()
      let projectLocal = this.projectLocal
      delete projectLocal.family_compositions
      delete projectLocal.family_references
      delete projectLocal.family_sicks
      delete projectLocal.working_condition
      delete projectLocal.laboral_references
      delete projectLocal.family_interviews      
      delete projectLocal.personal_references
      let required_fields = this.checkRequiredFields(projectLocal)
      if (required_fields == true) {
        axios.put(`/update_information_project`, { project: projectLocal }).then(res=>{
          if(res.status == 200){
            this.showMessage('Proceso actualizado', 'alert-success')
            eventBus.$emit('goToNextTab')
          }else{
            this.showMessage('El registro no se pudo actualizar', 'alert-danger')
          }
        }, (err) => {
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        })
      }
    },
    checkRequiredFields(projectLocal){
      let response = true
      let message = ''
      this.required_fields.forEach(field => {        
        if ((projectLocal[field.key] == null || projectLocal[field.key] == '') && projectLocal[field.key] != 0){
          message += field.message
          response = false
        }
      });
      if (!response) {
        this.showMessage(message, 'alert-danger')
      }
      return response
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 10000)
    },    
   	showMessageMaker(message, typeMessage){
			this.messageMaker = message
			this.typeMessageMaker = typeMessage
			setTimeout(() => this.messageMaker = '', 10000)
		},     
  },
  filters: {
    fnName: function(value) {
      return value;
    }
  },
  created () {
    eventBus.$on('saveProject', dataPassed => {
      this.save()
    })
  },
  mounted() {
    this.geolocate();
  }  
}
</script>

<style scoped>

</style>